/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_OptionsInputs */

const en_audio_options = /** @type {(inputs: Audio_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio options`)
};

const es_audio_options = /** @type {(inputs: Audio_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones de audio`)
};

/**
* | output |
* | --- |
* | "Audio options" |
*
* @param {Audio_OptionsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audio_options = /** @type {((inputs?: Audio_OptionsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_OptionsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_audio_options(inputs)
	return en_audio_options(inputs)
});